import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lob-dialog',
  templateUrl: './lob-dialog.component.html',
  styleUrls: ['./lob-dialog.component.css']
})
export class LobDialogComponent implements OnInit {
  //getquote: any;
  navigate: any;
  openCont = true;
  openMenu = true;
  constructor(public dialogRef: MatDialogRef<LobDialogComponent>, public global: GlobalService, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any, ) { }

  ngOnInit() {
    /*
    if (this.data == "getQuote") {
      this.getquote = 1;
    } else if (this.data == "claimIntimation") {
      this.getquote = 2;
    }
    else if (this.data == "endorsementRequest") {
      this.getquote = 3;
    }
    console.log("this.getquote",this.data,this.getquote)
    */
  }
  closeLob(): void {
    this.openMenu = false;
    this.openCont = false;
    setTimeout(() => {
      this.dialogRef.close();
    }, 500)

  }
  gotoProductExplore(name) {

    this.openMenu = false;
    this.openCont = false;
    setTimeout(() => {
      this.dialogRef.close();
      if(name == "Medical") {
        
        if(this.data.operation == "endorsement") {
          this.global.GotoPage("medical/broker/endorsement")
        }else if(this.data.operation == "renewal") {
          this.global.GotoPage("medical/broker/renewal/renewalRequest")
        } else {
          /* this.global.GotoPage("renewal/renewalRequest") */
          this.global.GotoPage("medical/broker/claims/claimIntimation")
          
        }
      } else {
        
        if(this.data.operation == "endorsement") {
          this.global.GotoPage("endorsement/endorsementRequest")
        } 
        else if(this.data.operation == "renewal") {
          this.global.GotoPage("renewal/renewalRequest")
        }else {
          this.global.GotoPage("claim/claimIntimation")
        }
      }
      /*
      if (this.getquote == 1) {
        if (name == "Motor") {
          //this.router.navigateByUrl('portal/motor/products/productlists')
          this.global.GotoPage('portal/motor/products/productlists');
        } else if (name == "Travel") {
          this.global.GotoPage('portal/travel/products/productlists');
        } else if (name == "Health") {
          this.global.GotoPage('portal/medical/products/productlists');
        } else if (name == "Personal Accident") {
          this.global.GotoPage('portal/personalaccident/products/productlists');
        }
      } else if (this.getquote == 2) {
        this.gotoClaimIntimation(name);
      }
      else if (this.getquote == 3) {
        this.gotoEndorsementRequest(name);
      }
      */
    }, 500)

  }
  gotoClaimIntimation(name) {
    if (name == "Motor") {
      this.router.navigate(['portal/motor/claims/claimIntimation']);
    } else if (name == "Travel") {
      this.global.GotoPage('portal/travel/products/productlists');
    } else if (name == "Health") {
      this.global.GotoPage('portal/medical/broker/claims/claimIntimation');
    } else if (name == "Personal Accident") {
      this.global.GotoPage('portal/personalaccident/claims/claimIntimation');
    }
  }

    gotoEndorsementRequest(name) {
      console.log("name",name)
      if (name == "Motor") {
        this.router.navigate(['portal/motor/endorsements/endorsementRequest']);
      } else if (name == "Travel") {
        this.global.GotoPage('portal/travel/products/productlists');
      } else if (name == "Health") {
        this.global.GotoPage('portal/medical/broker/endorsements/endorsementRequest');
      } else if (name == "Personal Accident") {
        this.global.GotoPage('portal/personalaccident/endorsements/endorsementRequest');
      }
    }
  
}
